
import ArticleArchivesAuthorPage from '~/pages/article/index.vue';

export default ArticleArchivesAuthorPage;
